import { get, post } from '@/utils/apiBase.js';

// cp后台项目信息
const getCpAdminProjectInfo = option => {
  return get('/apis/project/cp_admin/pro_info', option)
}
// 获取项目预览token
const getPreviewToken = option => {
  return get('/apis/project/cp/preview_token', option)
}
// 修改运营手机号
const updateProTelephone = option => {
  return post('/apis/product/update_pro_telephone', option)
}

export default {
  getCpAdminProjectInfo,
  getPreviewToken,
  updateProTelephone
};
